// frontend/src/pages/BulkAnalysisPage/useUnsavedChangesWarning.js

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useUnsavedChangesWarning = (isDirty) => {
    const { t } = useTranslation();
    const message = t('bulkAnalysisPage.dialogs.unsavedChanges.description');

    useEffect(() => {
        const beforeUnloadHandler = (event) => {
            if (isDirty) {
                event.preventDefault();
                // For modern browsers
                event.returnValue = message;
                // For older browsers
                return message;
            }
        };

        window.addEventListener('beforeunload', beforeUnloadHandler);

        return () => {
            window.removeEventListener('beforeunload', beforeUnloadHandler);
        };
    }, [isDirty, message]);
};

export default useUnsavedChangesWarning;